import Vue from 'vue'
import {mapMutations} from 'vuex'
import {mutationTypes} from '@/commons/constants'

Vue.mixin({
    methods: {
        mostrarNotificacaoErro(mensagem) {
            this[mutationTypes.MOSTRAR_MENSAGEM_ERRO](mensagem)
        },
        mostrarNotificacaoErroDefault() {
            this[mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT]()
        },
        mostrarNotificacaoSucessoDefault() {
            this[mutationTypes.MOSTRAR_MENSAGEM_SUCESSO_DEFAULT]()
        },
        mostrarNotificacaoSucesso(mensagem) {
            this[mutationTypes.MOSTRAR_MENSAGEM_SUCESSO](mensagem)
        },
        mostrarNotificacaoWarning(mensagem) {
            this[mutationTypes.MOSTRAR_MENSAGEM_WARNING](mensagem)
        },
        ...mapMutations([
            mutationTypes.MOSTRAR_MENSAGEM_ERRO,
            mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT,
            mutationTypes.MOSTRAR_MENSAGEM_SUCESSO_DEFAULT,
            mutationTypes.MOSTRAR_MENSAGEM_SUCESSO,
        ])
    }
})
